
const ScreenWidth = document.documentElement.clientWidth || window.innerWidth;

var mySwiper = new Swiper ('#swiper', {
  autoplay: 100,
  direction: 'horizontal', // 垂直切换选项
  loop: true, // 循环模式选项
  paginationClickable :true,
  
  // 如果需要分页器
  pagination: {
    el: '.swiper-pagination',
  }
}) 